import state from "./moduleUserSettingState";
import mutations from "./moduleUserSettingMutations";
import actions from "./moduleUserSettingActions";
import getters from "./moduleUserSettingGetters";

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}